module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Published by "), _c('b', [_c('i', [_vm._v("ePublishing Works!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('span', {
    staticClass: "s1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.epublishingworks.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.epublishingworks.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("ISBN: 978-1-61417-453-0")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "flourish",
      "src": "images/flourish.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("By payment of required fees, you have been granted the "), _c('i', [_vm._v("non")]), _vm._v("-exclusive, "), _c('i', [_vm._v("non")]), _vm._v("-transferable right to access and read the text of this eBook. No part of this text may be reproduced, transmitted, downloaded, decompiled, reverse engineered, or stored in or introduced into any information storage and retrieval system, in any form or by any means, whether electronic or mechanical, now known or hereinafter invented without the express written permission of copyright owner.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Please Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This is a work of fiction. Names, characters, places, and incidents either are the product of the author's imagination or are used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events or locales is entirely coincidental.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The reverse engineering, uploading, and/or distributing of this eBook via the internet or via any other means without the permission of the copyright owner is illegal and punishable by law. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author's rights is appreciated.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Copyright © 2013 by Jeanne Glidewell. All rights reserved under International and Pan-American Copyright Conventions.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cover and eBook design by eBook Prep "), _c('a', {
    attrs: {
      "href": "http://www.ebookprep.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "s2"
  }, [_vm._v("www.ebookprep.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23ab6361","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section4.vue
// module id = 66
// module chunks = 0